const getIsClampEnabled = (el?: HTMLElement | null) =>
  el ? el.scrollHeight > el.clientHeight : false;

export default getIsClampEnabled;
